__turbopack_context__.v({
  "card": "component-module__4ME7TG__card",
});
